// Client helper for the dev/integration-only lifecycle-simulation route. Routes
// through apiClient (no stray fetch — the qa strayFetch ratchet stays at 0).

import { apiPost } from "./apiClient";

/** Build the POST body for a simulate action; verdict only applies to resolve. */
export function simPayload(action, verdict) {
  return action === "resolve" ? { action, verdict } : { action };
}

/** Fire a simulated lifecycle event for one forecast (by wire client_id). */
export function postSimulate(forecastId, action, verdict) {
  return apiPost(
    `/api/forecasts/${encodeURIComponent(forecastId)}/simulate-lifecycle`,
    simPayload(action, verdict),
  );
}
